module.exports = __webpack_public_path__ + "static/media/loupsGarous_02_thumb_hover.df913173.png";